import axios from 'axios'
import { castAttributesForCamelCase } from '../../../../modules/string_converter'
import { i18n } from '../../../../plugins/i18n'

export const companiesStoreOcMapionBiz = {
  namespaced: true,
  state: {
    data: null,
    loading: false,
  },
  mutations: {
    apiConnect(state) {
      state.loading = true
    },
    readStoreOcMapionBizSuccess(state, payload) {
      state.data = castAttributesForCamelCase(payload.data)
      state.loading = false
    },
    createStoreOcMapionBizSuccess(state, payload) {
      state.data = castAttributesForCamelCase(payload.data)
      state.loading = false
    },
    apiSuccess(state) {
      state.loading = false
    },
    apiFailure(state) {
      state.loading = false
    }
  },
  actions: {
    readStoreOcMapionBiz({ commit, rootState }) {
      commit('apiConnect')
      return axios
        .get(`/api/companies/${rootState.route.params.company_uuid}/stores/${rootState.route.params.store_uuid}/oc/mapion_biz`)
        .then(res => {
          commit('readStoreOcMapionBizSuccess', res.data)
        })
        .catch(err => {
          commit('apiFailure')
          commit('flash/updateFlash',{ type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
        })
    },
    createStoreOcMapionBiz({ commit, rootState }, mapionBizId) {
      commit('apiConnect')
      const payload = {
        store_oc_mapion_biz: {
          mapion_biz_id: mapionBizId
        }
      }
      return axios
        .post(`/api/companies/${rootState.route.params.company_uuid}/stores/${rootState.route.params.store_uuid}/oc/mapion_biz`, payload)
        .then(res => {
          commit('createStoreOcMapionBizSuccess', res.data)
          commit('flash/updateFlash',{ type: 'notice', message: i18n.t('pages.CompaniesLocationStore.connectionWithMapionBiz.connectSuccess') }, { root: true })
          return true
        })
        .catch(err => {
          commit('apiFailure')
          commit('flash/updateFlash',{ type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          return false
        })
    },
    deleteStoreOcMapionBiz({ commit, rootState }) {
      commit('apiConnect')
      return axios
        .delete(`/api/companies/${rootState.route.params.company_uuid}/stores/${rootState.route.params.store_uuid}/oc/mapion_biz`)
        .then(res => {
          commit('apiSuccess', res.data)
          commit('flash/updateFlash',{ type: 'notice', message: i18n.t('pages.CompaniesLocationStore.connectionWithMapionBiz.disconnectSuccess') }, { root: true })
          return true
        })
        .catch(err => {
          commit('apiFailure')
          commit('flash/updateFlash',{ type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          return false
        })
    },
  }
}
